import Risk from "./Risk.container";
export default Risk;
